import React, { FC, ReactNode, useEffect, useState } from "react";

export const DelayRender: FC<{
  delay: number;
  fallback?: ReactNode;
}> = ({ delay = 0, fallback = null, children }) => {
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setShouldRender(true);
    }, delay);
  }, [delay]);

  return <>{shouldRender ? children : fallback}</>;
};
